window.gMapsLoaded = false;
window.gMapsCallback = function () {
    window.gMapsLoaded = true;
    $(window).trigger('gMapsLoaded');
};
window.loadGoogleMaps = function () {
    if ( window.gMapsLoaded ) return window.gMapsCallback();
    var script_tag = document.createElement('script');
    script_tag.setAttribute("type","text/javascript");
    script_tag.setAttribute("src","https://maps.google.com/maps/api/js?key=AIzaSyCGJSKk9RRJAqlrsKXN2xTRQhYL9F-Pw70&callback=gMapsCallback");
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
};